const Footer = () => {
  return (
    <footer>
      <p>Developed en designed met passie 💯 Sander Schijf</p>
    </footer>
  );
};

export default Footer;